import "./App.css";
import CheckinComponent from "./components/CheckinComponent";
import ErrorComponent from "./components/ErrorComponent";
import CheckinSuccess from "./components/ChecInOutConfirmation";
import DateTimeHeader from "./components/DateTimeHeader";
import Loader from "./components/Loader";
import logo from "./images/logo.png";
// import { getSessions } from "./api";
import { useEffect, useState } from "react";
import io from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_API_BASE || "http://localhost:5000";

function App() {
  // const [sessions, setSessions] = useState([]);
  const [lastEvent, setLastEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      console.log("Stands and sessions loaded");
    }
    load();

    const socket = io(SOCKET_URL);
    socket.on("checkin", (data) => {
      setLastEvent({ type: "checkin", data });
      console.log(data);
      setLoading(false);
    });
    socket.on("checkout", (data) => {
      let checkoutRes = data?.checkOutUpdate?.details?.output
        ? JSON.parse(data.checkOutUpdate.details.output)
        : {};
      let standName = checkoutRes?.Stand || "N/A";
      console.log("Checkout stand name:", standName);
      setLastEvent({ type: "checkout", standName: standName });
      console.log(data);
      setLoading(false);
    });

    socket.on("error", (error) => {
      console.log("Socket error received:", error);
      setLastEvent({ type: "error", error });
      setLoading(false);
    });
    // const interval = setInterval(() => {
    //   setDateTime(new Date());
    // }, 1000);
    return () => {
      socket.disconnect()
      // clearInterval(interval);
    };
  }, []);

  if (loading) return <Loader />;

  return (
    <div>
      {lastEvent?.type === "checkin" && (
        <CheckinComponent session={lastEvent.data} onDone={() => setLoading(true)} />
      )}

      {lastEvent?.type === "checkout" && (
        <div className="checkin-container">
          {/* HEADER */}
          <div className="checkin-header">
            <img src={logo} alt="logo" width="400px" />

            <div className="header-datetime">
              <DateTimeHeader />
            </div>
          </div>

          <CheckinSuccess stand={lastEvent.standName} info={"ausgecheckt"} check={"checkout"} onDone={() => setLoading(true)} />
        </div>
      )}

      {lastEvent?.type === "error" && (
        <div className="checkin-container">
          {/* HEADER */}
          <div className="checkin-header">
            <img src={logo} alt="logo" width="400px" />

            <div className="header-datetime">
              <DateTimeHeader />
            </div>
          </div>
          <ErrorComponent error={lastEvent.error} />
        </div>
      )}
    </div>
  );
}
export default App;